<template>
  <div class="mod-menu">
    <a-form :inline="true" :model="dataForm">
      <a-form-item>
        <a-button size="small" type="primary" @click="addOrUpdateHandle()"
          >上传</a-button
        >
      </a-form-item>
    </a-form>
    <div>
      <div
        class="card"
        v-for="item in dataList"
        :key="item.mediaId"
        @click="onSelect(item)"
      >
        <div class="flex justify-between align-right">
          <a-button
            size="small"
            type="link"
            icon="delete"
            style="float: right"
            @click="deleteHandle(item.mediaId, wechatAppId)"
          ></a-button>
        </div>
        <img v-if="fileType == 'image'" class="card-image" :src="item.url" />
        <div v-else class="card-preview">
          <div
            v-if="fileType == 'voice'"
            class="card-preview-icon el-icon-microphone"
          ></div>
          <div
            v-if="fileType == 'video'"
            class="card-preview-icon el-icon-video-camera-solid"
          ></div>
          <div class="card-preview-text">
            管理后台不支持预览<br />微信中可正常播放
          </div>
        </div>
        <div class="card-footer">
          <div class="text-cut-name">{{ item.name }}</div>
        </div>
      </div>
    </div>
    <a-pagination
      size="small"
      show-quick-jumper
      :page-size-options="pageSizeOptions"
      :total="totalCount"
      :page-size="pageSize"
      show-size-changer
      :current="pageIndex"
      @showSizeChange="onShowSizeChange"
      @change="onChange"
    />
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update
      v-if="addOrUpdateVisible"
      ref="addOrUpdate"
      @refreshDataList="onChange"
    ></add-or-update>
  </div>
</template>
<script>
import AddOrUpdate from './material-file-add-or-update';
import { getAction, postAction } from '@/api/manage';
export default {
  name: 'material-file',
  props: {
    fileType: {
      // image、voice、video
      type: String,
      default: 'image',
    },
    selectMode: {
      // 是否选择模式，选择模式下点击素材选中，不可新增和删除
      type: Boolean,
      default: false,
    },
  },
  components: {
    AddOrUpdate,
  },
  data() {
    return {
      dataForm: {},
      addOrUpdateVisible: false,
      editInputVisible: true,
      wechatAppId: '',
      dataList: [],
      pageIndex: 1,
      pageSize: 20,
      totalCount: 0,
      dataListLoading: false,
      pageSizeOptions: ['5', '10', '15', '20'],
    };
  },
  mounted() {},
  methods: {
    init(wechatAppId) {
      this.wechatAppId = wechatAppId;
    },
    getFileBatch(wechatAppId) {
      this.wechatAppId = wechatAppId;
      if (this.dataListLoading) return;
      this.dataListLoading = true;
      getAction(
        process.env.VUE_APP_CMS_WECHAT +
          '/wechat/material/materialFileBatchGet',
        { appId: wechatAppId, page: this.pageIndex, pageSize: this.pageSize }
      ).then((res) => {
        if (res.success && res.code == 200) {
          this.dataList = res.result.items;
          this.totalCount = res.result.totalCount;
        } else {
          this.$message.error(res.message);
          this.dataList = [];
          this.totalCount = 0;
        }
        this.dataListLoading = false;
      });
    },
    // 新增 / 修改
    addOrUpdateHandle() {
      if (!this.wechatAppId) {
        this.$message.warning('请选择渠道');
      } else {
        this.addOrUpdateVisible = true;
        this.$nextTick(() => {
          this.$refs.addOrUpdate.init(this.fileType, this.wechatAppId);
        });
      }
    },
    onSelect(itemInfo) {
      if (!this.selectMode) return;
      this.$emit('selected', itemInfo);
    },
    //删除
    deleteHandle(id, wechatAppId) {
      let that = this;
      this.$confirm({
        title: '确定删除吗',
        content: '确定要删除选定的素材吗',
        onOk() {
          postAction(
            process.env.VUE_APP_CMS_WECHAT + '/wechat/material/removeMaterial',
            { appId: wechatAppId, mediaId: id }
          ).then((res) => {
            if (res.success && res.code === 200) {
              that.$message.success('操作成功');
              that.getFileBatch(wechatAppId);
              that.$emit('change');
            } else {
              that.$message.error(res.message);
            }
          });
        },
        onCancel() {},
      });
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    onCopySuccess() {
      this.$message.success('已复制');
    },
    onCopyError(err) {
      this.$message.error('复制失败,可能是此浏览器不支持复制');
    },
    onChange(pageIndex) {
      this.pageIndex = pageIndex;
      this.getFileBatch(this.wechatAppId);
    },
    onShowSizeChange(pageIndex, pageSize) {
      if (!this.wechatAppId) {
        this.$message.warning('请选择渠道');
      } else {
        this.pageSize = pageSize;
        this.getFileBatch(this.wechatAppId);
      }
    },
    edit() {
      this.editInputVisible = false;
      console.log(this.editInputVisible);
    },
  },
};
</script>
<style scoped>
.card {
  width: 170px;
  display: inline-block;
  background: #ffffff;
  border: 1px solid #ebeef5;
  box-shadow: 1px 1px 20px 0 rgba(0, 0, 0, 0.1);
  margin: 0 10px 10px 0;
  vertical-align: top;
  border-radius: 5px;
  box-sizing: border-box;
}
.card:hover {
  border: 2px solid #66b1ff;
  margin-bottom: 6px;
}
.card-image {
  line-height: 170px;
  max-height: 170px;
  width: 100%;
}
.card-preview {
  padding: 20px 0;
  color: #d9d9d9;
  display: flex;
  justify-content: center;
  align-items: center;
}
.card-preview-icon {
  font-size: 30px;
  margin-right: 5px;
}
.card-preview-text {
  font-size: 12px;
}
.card-footer {
  color: #ccc;
  font-size: 12px;
  padding: 15px 10px;
  overflow: hidden;
}
</style>
